import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Button } from "./ui/button";

let deferred = null;
const listeners = new Set();
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
  listeners.forEach((fn) => fn(true));
});

export const InstallButton = ({ className = "" }) => {
  const [ready, setReady] = useState(!!deferred);
  useEffect(() => {
    listeners.add(setReady);
    return () => listeners.delete(setReady);
  }, []);
  if (!ready) return null;
  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    deferred = null;
    listeners.forEach((fn) => fn(false));
  };
  return (
    <Button type="button" variant="outline" size="sm" onClick={install} className={`rounded-full ${className}`} data-testid="pwa-install-button">
      <Download className="h-4 w-4 mr-1" />Install
    </Button>
  );
};
